import axios from '../api/axios';

export default {
    getVenueList(params, callback){ // 列表
        axios.post(`/v1/admin/venueAccount/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getPlatformFeesList({params, callback}){ // 列表详情
        axios.post(`/v1/admin/venueFees/platformFeesList`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    createVenue(params, callback){ // 新增场馆
        axios.post(`/v1/admin/venueAccount/add`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getDoshiList(pat,callback){
        axios.post(`/v1/doshii/list`,pat).then(res=>{
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getDoshiDetail(pat,callback){
        axios.get(`/v1/doshii/detail/${pat.id}`,pat).then(res=>{
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/dishi.js